export default __webpack_public_path__ + "static/media/7.de80ac8f.jpeg";